import { newUid } from "@/lib/helpers";

export default {
  state: {
    notificationStack: []
  },

  mutations: {
    addNotification(state, notification) {
      state.notificationStack = [...state.notificationStack, notification];
    },
    removeNotification(state, uid) {
      state.notificationStack = state.notificationStack.filter(n => n.uid !== uid);
    }
  },

  actions: {
    notify({ commit }, notification) {
      commit("addNotification", {
        duration: 6000,
        ...notification,
        uid: newUid.next().value
      });
    },
    closeNotification({ commit }, uid) {
      commit("removeNotification", uid);
    }
  }
};
